import { createClient } from '@supabase/supabase-js';

// Capture redirect type flags before Supabase processes and clears the hash
export const isInviteRedirect =
  typeof window !== 'undefined' && window.location.hash.includes('type=invite');

export const isPasswordRecovery =
  typeof window !== 'undefined' && window.location.hash.includes('type=recovery');

export const supabase = createClient(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_ANON_KEY
);
